var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletInvestment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#02769D",
    strokeWidth: 2,
    fill: "#E7F3F9",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#02769D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.82 23.786h3.663c.725 0 1.313.587 1.313 1.313v6.03h-6.29V25.1c0-.726.587-1.313 1.313-1.313zM23.217 19.587h3.664c.725 0 1.313.587 1.313 1.313v10.23h-6.29V20.9c0-.726.588-1.313 1.313-1.313zM31.598 15.388h3.663c.726 0 1.314.587 1.314 1.313V31.13h-6.29V16.7c0-.725.587-1.312 1.313-1.312zM12.452 33.48c0-.432.345-.795.795-.795H36.85c.432 0 .795.345.795.795a.793.793 0 0 1-.795.795H13.247a.804.804 0 0 1-.795-.795z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletInvestment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-investment.4ace1f21c69804aa843d31b900d6fe7a.svg";